import { SourceDomain } from '@pflegia/types/api/source-domain';

export const getPflegiaDefaultDomainName = (sourceDomains: SourceDomain | SourceDomain[]) => {
  const domains = [sourceDomains].flat();
  const hasPraxia = domains.includes(SourceDomain.PraxiaDe);
  const hasPflegia = domains.includes(SourceDomain.PflegiaDe) || domains.includes(SourceDomain.PflegiaAt);

  return hasPraxia && !hasPflegia ? SourceDomain.PraxiaDe : SourceDomain.PflegiaDe;
};
